export enum PermissionEnum {
  CAN_ADMINISTRATE_SYSTEM = 'CAN_ADMINISTRATE_SYSTEM',

  CAN_LIST_EMPLOYEES = 'CAN_LIST_EMPLOYEES',
  CAN_EDIT_EMPLOYEE = 'CAN_EDIT_EMPLOYEE',
  CAN_ADD_EMPLOYEE = 'CAN_ADD_EMPLOYEE',
  CAN_REMOVE_EMPLOYEE = 'CAN_REMOVE_EMPLOYEE',

  CAN_LIST_FOREIGNERS = 'CAN_LIST_FOREIGNERS',
  CAN_EDIT_FOREIGNER = 'CAN_EDIT_FOREIGNER',
  CAN_ADD_FOREIGNER = 'CAN_ADD_FOREIGNER',
  CAN_REMOVE_FOREIGNER = 'CAN_REMOVE_FOREIGNER',

  CAN_USE_MOBILE = 'CAN_USE_MOBILE',

  CAN_EDIT_OWN_DATA = 'CAN_EDIT_OWN_DATA',
  CAN_ACTIVATE_OWN_ACCOUNT = 'CAN_ACTIVATE_OWN_ACCOUNT',

  CAN_LIST_COMPANIES = 'CAN_LIST_COMPANIES',
  CAN_EDIT_COMPANY = 'CAN_EDIT_COMPANY',
  CAN_ADD_COMPANY = 'CAN_ADD_COMPANY',
  CAN_REMOVE_COMPANY = 'CAN_REMOVE_COMPANY',

  CAN_EDIT_VISIT = 'CAN_EDIT_VISIT',
  CAN_REMOVE_VISIT = 'CAN_REMOVE_VISIT',

  CAN_READ_USER_PROCESS_HISTORY = 'CAN_READ_USER_PROCESS_HISTORY',

  // EMPLOYER
  CAN_LIST_COMPANY_EMPLOYEES = 'CAN_LIST_COMPANY_EMPLOYEES',
  CAN_DISPLAY_COMPANY_EMPLOYEE_APPLICATION_STATUS = 'CAN_DISPLAY_COMPANY_EMPLOYEE_APPLICATION_STATUS',

  CAN_MANAGE_USERS_PARTNER_ACCOUNT = 'CAN_MANAGE_USERS_PARTNER_ACCOUNT',
  CAN_MANAGE_USERS_TAGS = 'CAN_MANAGE_USERS_TAGS',

  CAN_START_NEW_CANDIDATE_VERIFICATION = 'CAN_START_NEW_CANDIDATE_VERIFICATION',
  CAN_VIEW_CANDIDATE_VERIFICATIONS = 'CAN_VIEW_CANDIDATE_VERIFICATIONS',

  CAN_SEE_CANDIDATE_VERIFICATION_DETAILS = 'CAN_SEE_CANDIDATE_VERIFICATION_DETAILS',
  CAN_DELETE_CANDIDATE_VERIFICATION = 'CAN_DELETE_CANDIDATE_VERIFICATION',
  CAN_EDIT_CANDIDATE_VERIFICATION = 'CAN_EDIT_CANDIDATE_VERIFICATION',

  /**
   * ===================== TASKS RELATED PERMISSIONS
   */
  CAN_LIST_OWN_TASKS = 'CAN_LIST_OWN_TASKS', // Admin, Team Leader, Employee, Field Consultant
  CAN_LIST_OTHERS_TASKS = 'CAN_LIST_OTHERS_TASKS', // Admin, Team Leader
  CAN_CLOSE_TASKS_OF_OTHERS = 'CAN_CLOSE_TASKS_OF_OTHERS', // Admin, Team Leader

  /**
   * ===================== TRACKING RELATED PERMISSIONS
   */
  CAN_LIST_TRACKING = 'CAN_LIST_TRACKING', // Admin, Team Leader, Employee, Employer
  CAN_ADD_EDIT_TRACKING = 'CAN_ADD_EDIT_TRACKING', // Admin, Team Leader, Employee, Employer
  CAN_DELETE_TRACKING = 'CAN_DELETE_TRACKING', // Admin, Team Leader, Employee
  CAN_MANAGE_TRACKING_USER_RELATION = 'CAN_MANAGE_TRACKING_USER_RELATION', // Admin, Team Leader, Employee

  /**
   * ===================== WORK PERMIT RELATED PERMISSIONS
   */
  CAN_VIEW_WORK_PERMIT = 'CAN_VIEW_WORK_PERMIT', // Admin, Team Leader, Employee, Employer
  CAN_EDIT_WORK_PERMIT = 'CAN_EDIT_WORK_PERMIT', // Admin, Team Leader, Employee, Employer
  CAN_DELETE_WORK_PERMIT = 'CAN_DELETE_WORK_PERMIT', // Admin, Team Leader, Employee, Employer
}

export interface Permission {
  id: string;
  name: string;
  key: PermissionEnum;
}
